import axios from 'Services/axios';

import type { SellerCommunicationUnsentMessagesCountResult } from './request';

export type GetSellerCommunicationUnsentMessagesCountClientApiCall = () => SellerCommunicationUnsentMessagesCountResult;

const SELLER_COMMUNICATIONS_UNSENT_MESSAGES_COUNT_CLIENT_ENDPOINT = '/api/seller-communications/unsent-messages-count';

export const getSellerCommunicationUnsentMessagesCount: GetSellerCommunicationUnsentMessagesCountClientApiCall =
	async () => {
		const res = await axios.get(SELLER_COMMUNICATIONS_UNSENT_MESSAGES_COUNT_CLIENT_ENDPOINT);
		return res.data as ReturnType<GetSellerCommunicationUnsentMessagesCountClientApiCall>;
	};
